export enum NoteOnChainStatus {
  ACTIVE = 'ACTIVE',
  SPENT = 'SPENT',
  LOCKED = 'LOCKED',
  UNKNOWN = 'UNKNOWN'
}
